import FooterNavbar from "../../footernavbar/FooterNavbar";

const MagzinesInside = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <div
          className="page-header min-vh-55"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20(1%20of%201)-5.jpg?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80&#39;')",
          }}
        >
          <span className="mask bg-gradient-dark"></span>
          <div className="container w-80 d-flex justify-content-center mx-auto">
            <div className=" w-100 shadow-lg">
              <div className=" d-flex justify-content-start align-items-center gap-3">
                <div className="card-header mt-2 mx-2 p-0 bg-transparent position-relative z-index-2">
                  <a
                    href="/MagzinesInside"
                    className="d-block blur-shadow-image"
                  >
                    <img
                      src="../../assets/img/magzines/magzine-1.jpg"
                      alt="img-blur-shadow"
                      className=" border-radius-lg height-500"
                    />
                  </a>
                </div>
                <div className=" w-100 lh-2">
                  <b className=" text-white text-5xl fw-bolder">
                    Entrepreneur of the Year 2023 Vol 4
                  </b>
                  <p className=" text-white">
                    With an innovative approach towards sheathing businesses,
                    start-up, technology and entrepreneurs, CEO Review Magazine
                    covers business news insights.
                    <br /> We research and keep you on top of the latest trend
                    with interesting content all around.
                  </p>
                </div>
                <div className=" w-100"></div>
              </div>
            </div>
          </div>
        </div>
        <div className=" w-70 container mx-auto">
          <div className=" mt-3 text-center">
            <h1>
              <sup>
                {" "}
                <i
                  className="ri-double-quotes-l text-dark text-5xl"
                  aria-hidden="true"
                ></i>{" "}
              </sup>
              Success usually comes to those who are too busy to be looking for
              it.
              <sup>
                {" "}
                <i
                  className="ri-double-quotes-r text-dark text-5xl"
                  aria-hidden="true"
                ></i>{" "}
              </sup>
              - Henry David Thoreau
            </h1>
            <div className=" text-start">
              <b className=" text-black fw-normal">
                Steve Jobs once said, “If you really look closely, most
                overnight successes took a long time.” The maverick was
                absolutely right in saying so as no successful company is built
                overnight. It takes a lot of perseverance, rock solid will to
                withstand the testing times, and above all the never-say-never
                attitude. In this issue, we have featured such companies which
                stood the tough times and emerge victorious over a period of
                time. Winston Churchll, former Prime Minister of the United
                Kingdom once said, “Success is not final; failure is not fatal:
                it is the courage to continue that counts.”
              </b>
            </div>
            <div className=" text-start mt-4">
              <b className=" text-black fw-normal">
                Running a company requires a whole lot of attention and focus. A
                company need not get too overwhelmed by success, at the
                sametime, it should not get demotivated with failure. What
                matters here is the unwavering courage to run the company that
                works with a modus operandi of win-win situation. While running
                a business or company, problem is imminent and that is only when
                we get to know our weak links. This is why Anthony Robbins said,
                “Every problem is a gift—without problems we would not grow.” It
                is not a child’s play to remain rock solid in today’s
                circumstances. A whole lot of companies have rolled many heads
                owing to the losses during the lockdown.
              </b>
            </div>
            <div className=" text-start mt-4">
              <b className=" text-black fw-normal">
                Nevertheless, there are a number of companies who stood by their
                employees and offered support to them. We will get to learn a
                lot about how these companies battled it out with these times.
                How they are running their companies efficiently.
              </b>
            </div>
            <div className=" text-start mt-4">
              <b className=" text-black fw-normal">
              Enjoy reading!
              </b>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MagzinesInside;
